import { Buttons } from "./Buttons"

export function Bots(props){
    return(
        <div>
            <h1>This is a test {props.bots} testing</h1>
            <Buttons></Buttons>
        </div>
    )
}